import axios from 'axios';

const BASE_URL = "https://backoffice.primulahotels.com/console/"
export const API_KEY = "renai202509221613"
export const API_TOKEN = "biBh98y78GHJ564e6fu1ghBJB"

// Create global apiClient with interceptors
export const apiClient = axios.create();

// Response interceptor to handle authentication errors
apiClient.interceptors.response.use(
  (response) => {
    // Check if response indicates unauthenticated access
    const responseData = response.data;
    
    if (responseData && Array.isArray(responseData)) {
      const firstItem = responseData[0];
      if (firstItem && firstItem.status === 0 && firstItem.error2 === "Invalid user!") {
        triggerLogout();
        return Promise.reject(new Error('Unauthenticated'));
      }
    } else if (responseData && responseData.status === 0 && responseData.error2 === "Invalid user!") {
      triggerLogout();
      return Promise.reject(new Error('Unauthenticated'));
    }
    
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Function to trigger logout (you'll need to implement this based on your app structure)
const triggerLogout = () => {
  // This will be called from your components/stores
  // You can dispatch an event or call a global function
  console.log("Auto-logout triggered due to unauthenticated access");
  
  // Dispatch custom event that your components can listen to
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('user-unauthorized'));
  }
};

// Your existing functions (keep them as is)
export const FetchApi = (path, parameters) => {
  let query = "";
  let api_key = API_KEY
  let api_token = API_TOKEN
  let url = BASE_URL + 'api/'
  for (let key in parameters) {
    let value = parameters[key];
    query += encodeURIComponent(key) + "=" + encodeURIComponent(value) + "&";
  }
  if (query.length > 0) {
    query = query.substring(0, query.length - 1);
    url = url + path + "?" + "apikey" + "=" + api_key + "&" + "apitoken" + "=" + api_token + "&" + query;
  }
  return url;
}

export const FetchApiNoParam = (path) => {
  let api_key = API_KEY
  let api_token = API_TOKEN
  let url = BASE_URL + 'api/'
  url = url + path + "?" + "apikey" + "=" + api_key + "&" + "apitoken" + "=" + api_token
  return url;
}